var map = {
	"./DentImg/AL2024T33.png": 409,
	"./DentImg/AL7075T63.png": 1722,
	"./DentImg/dent.png": 1148,
	"./Load/DoubleLap.png": 8382,
	"./Load/HardPoint.png": 2739,
	"./Load/Runout.png": 4234,
	"./Load/SingleLap.png": 783,
	"./Stress/DoubleLap.png": 425,
	"./Stress/HardPoint.png": 4402,
	"./Stress/Runout.png": 2068,
	"./Stress/SingleLap.png": 959,
	"./fatigue/AISI41301.png": 6064,
	"./fatigue/AISI41302.png": 5243,
	"./fatigue/AISI41303.png": 2789,
	"./fatigue/AISI41304.png": 7688,
	"./fatigue/AL2024T31.png": 6458,
	"./fatigue/AL2024T32.png": 2032,
	"./fatigue/AL2024T33.png": 8875,
	"./fatigue/AL2024T34.png": 8884,
	"./fatigue/AL2219T8511.png": 5153,
	"./fatigue/AL2219T8512.png": 1565,
	"./fatigue/AL2219T8513.png": 7605,
	"./fatigue/AL7050T7451.png": 5087,
	"./fatigue/AL7075T61.png": 5509,
	"./fatigue/AL7075T62.png": 8500,
	"./fatigue/AL7075T63.png": 5150,
	"./fatigue/AL7075T64.png": 7454,
	"./fatigue/AL7475T61.png": 1274,
	"./fatigue/AL7475T7351.png": 3900,
	"./fatigue/AL7475T761.png": 9314,
	"./fatigue/AL7475T7651.png": 4592,
	"./fatigue/PH155.png": 7751,
	"./fatigue/PH157Mo.png": 5765,
	"./fatigue/TI13V11CR3AL.png": 2296,
	"./fatigue/TI45AL3V2FE2MO.png": 891,
	"./fatigue/Ti6Al4V.png": 453,
	"./fatigue/Ti6Al4V1.png": 8220,
	"./fatigue/Ti8Al1Mo1V.png": 4775,
	"./logo.png": 6949,
	"./logo0.png": 2215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;